/**
 * Created by shoulm on 30/04/2017.
 */
import {Injectable, Inject} from 'ng-metadata/core';
import {StorageUtil} from "./storageUtil.service";
import {UUIDGenerator} from "../nddUtils/UUIDGenerator.service";
import {getVid} from '../appConfig/appConfigForward';


const SHARED_SESSION_STORAGE_MANIFEST_KEY= "sharedSessionStorageManifestByVid";
const SEND_SESSION_STORAGE_DATA_KEY= 'sendSharedSessionStorageData';
const REMOVE_SESSION_STORAGE_DATA_KEY= 'removeSharedSessionStorageData';
const GET_ALL_SESSION_STORAGE_DATA_REQUEST_KEY= 'getAllSharedSessionStorageDataRequest';
const SEND_GET_ALL_SESSION_STORAGE_DATA_KEY= 'sendGeAllSharedSessionStorageData';

@Injectable()
export class SharedSessionStorage{
    private uuid: string;

    constructor(private storageUtil: StorageUtil,
                 uuidGenerator: UUIDGenerator,){
        this.createNewSharedSessionStorageManifest();
        this.uuid= uuidGenerator.generateUUID();
        // listen for changes to localStorage
        if (window.addEventListener) {
            window.addEventListener("storage", (event)=>{this.onStorageEvent(event)}, false);
        } else {
            (<any>window).attachEvent("onstorage", (event)=>{this.onStorageEvent(event)});
        }
        //request all shared session storage data from existing tabs
        let dataObject ={uuid: this.uuid, vid: getVid()};
        let dataObjectString = JSON.stringify(dataObject);
        this.storageUtil.localStorage.setItem(GET_ALL_SESSION_STORAGE_DATA_REQUEST_KEY, dataObjectString); //place data on local storage to trigger storage event in other tabs
    }

    private initializeNewSharedSessionStorageManifest() {
        let manifest= {[getVid()] : []};
        this.storageUtil.sessionStorage.setItem(SHARED_SESSION_STORAGE_MANIFEST_KEY, JSON.stringify(manifest));
    }

    private removeSharedSeasionStorageKeyAndValue(key) {
        let shardedValueToDelete = this.getManifestValue(key);
        shardedValueToDelete.forEach((key) => this.storageUtil.sessionStorage.removeItem(key));
    }

    private createNewSharedSessionStorageManifest(){
        let sessionStorageManifest = this.storageUtil.sessionStorage.getItem(SHARED_SESSION_STORAGE_MANIFEST_KEY);
        sessionStorageManifest = sessionStorageManifest ? JSON.parse(sessionStorageManifest) : false;
        if(!sessionStorageManifest){
            this.initializeNewSharedSessionStorageManifest();
            return;
        }
        if(Object.keys(sessionStorageManifest)[0] !== getVid()){
            this.removeSharedSeasionStorageKeyAndValue(Object.keys(sessionStorageManifest)[0]);
            this.initializeNewSharedSessionStorageManifest();
        }
    }

    private onStorageEvent(event){
        if (!event) { event = window.event; } // for ie
        if (!event.newValue){
            return; //if no data then do nothing
        }
        switch (event.key){
            case SEND_SESSION_STORAGE_DATA_KEY:
                this.receiveDataEvent(event);
                break;
            case REMOVE_SESSION_STORAGE_DATA_KEY:
                this.removeDataEvent(event);
                break;
            case GET_ALL_SESSION_STORAGE_DATA_REQUEST_KEY:
                this.sendAllSharedSessionStorageData(event);
            default:
                return;
        }

    }

    private getManifest(): Object{
        let stringifiedManifest= this.storageUtil.sessionStorage.getItem(SHARED_SESSION_STORAGE_MANIFEST_KEY);
        return JSON.parse(stringifiedManifest);
    }

    private getManifestValue(vid:string = getVid()): Array<string> {
        let manifestValue = this.getManifest();
        return manifestValue[vid];
    }

    private addKeyToManifest(key){
        let manifest= this.getManifestValue();
        if (manifest.indexOf(key) === -1){
            manifest.push(key);
            let manifestObject = this.getManifest();
            manifestObject[getVid()] = manifest;
            this.storageUtil.sessionStorage.setItem(SHARED_SESSION_STORAGE_MANIFEST_KEY, JSON.stringify(manifestObject));
        }
    }

    private removeValueFromManifest(key, vid = getVid()){
        let manifest= this.getManifestValue(vid);
        let index= manifest.indexOf(key);
        if (index > -1){
            manifest.splice(index, 1);
            let manifestObject = this.getManifest();
            manifestObject[getVid()] = manifest;
            this.storageUtil.sessionStorage.setItem(SHARED_SESSION_STORAGE_MANIFEST_KEY, JSON.stringify(manifestObject));
        }
    }

    private sendAllSharedSessionStorageData(event){
        let dataObject = JSON.parse(event.newValue);

        if (dataObject.uuid === this.uuid || dataObject.vid != getVid()){
            return;  // do nothing if we have caught our own event (stupid IE)
        }
        let manifest= this.getManifestValue();
        for (let key of manifest){
            this.setItem(key, this.getItem(key));
        }
    }

    private receiveDataEvent(event){
        let dataObject = JSON.parse(event.newValue);
        if (dataObject.uuid === this.uuid || dataObject.vid != getVid()){
            return;  // do nothing if we have caught our own event (stupid IE)
        }
        this.addKeyToManifest(dataObject.key);
        this.storageUtil.sessionStorage.setItem(dataObject.key, dataObject.data);
    }


    private removeDataEvent(event){
        let dataObject = JSON.parse(event.newValue);
        if (dataObject.uuid === this.uuid || dataObject.vid != getVid()){
            return;  // do nothing if we have caught our own event (stupid IE)
        }
        this.storageUtil.sessionStorage.removeItem(dataObject.key);
        this.removeValueFromManifest(dataObject.key);
    }


    public setItem(key: string, value: string){
        let dataObject ={key: key, uuid: this.uuid, data: value, vid: getVid()};
        let dataObjectString = JSON.stringify(dataObject);
        this.storageUtil.localStorage.setItem(SEND_SESSION_STORAGE_DATA_KEY, dataObjectString); //place data on local storage to trigger storage event in other tabs
        this.storageUtil.localStorage.removeItem(SEND_SESSION_STORAGE_DATA_KEY); //remove the event data
        this.storageUtil.sessionStorage.setItem(key, value); //save the data in our own session storage
        this.addKeyToManifest(key);
    }

    public getItem(key: string){
        return this.storageUtil.sessionStorage.getItem(key);
    }

    public removeItem(key: string){
        let dataObject= {key: key, uuid: this.uuid, vid: getVid()};
        let dataObjectString = JSON.stringify(dataObject);
        this.storageUtil.localStorage.setItem(REMOVE_SESSION_STORAGE_DATA_KEY, dataObjectString); //place data on local storage to trigger storage event in other tabs
        this.storageUtil.sessionStorage.removeItem(key);  //remove the data from our own session storage
        this.storageUtil.localStorage.removeItem(REMOVE_SESSION_STORAGE_DATA_KEY); //remove the event data
        this.removeValueFromManifest(dataObject.key);
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/sharedSessionStorage.service.ts